module.exports = __webpack_public_path__ + "img/POST.0c00d52e.svg";